import * as Yup from 'yup'
import {LongDescription, MediumTitle} from 'Validations'

export const Validation = Yup.object({
  title: MediumTitle.required('Title is required'),
  month: Yup.number(),
  year: Yup.number().required('Field required'),
  description: LongDescription,
})
